import { Injectable } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { DsModalService, DsModalVariant } from '@levelaccess/design-system';
import { AiChatService } from './ai-chat.service';
import { AiChatRenameModalComponent } from './ai-chat-rename-modal/ai-chat-rename-modal.component';
import { NotificationService } from '../../services/notification.service';
import { NotificationPosition } from '../../models/notification.model';
import { TranslateService } from '../../translate/translate.service';

@Injectable({ providedIn: 'root' })
export class AiChatRenameService {
  constructor(
    private dsModalService: DsModalService,
    private aiChatService: AiChatService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  confirmAndRenameSession(sessionId: string, currentTitle: string, triggerElement?: HTMLElement): Observable<void> {
    const modalRef = this.dsModalService.open(AiChatRenameModalComponent, DsModalVariant.center);
    const modal: AiChatRenameModalComponent = modalRef.componentInstance as AiChatRenameModalComponent;
    modal.currentTitle = currentTitle;

    let wasSaved = false;
    let savedTitle = '';
    modalRef?.hidden?.pipe(take(1)).subscribe((): void => {
      if (!wasSaved) {
        triggerElement?.focus();
      }
    });

    return outputToObservable(modal.save).pipe(
      take(1),
      tap((title: string): void => {
        wasSaved = true;
        savedTitle = title;
      }),
      switchMap((title: string): Observable<void> => this.aiChatService.renameChatSession(sessionId, title)),
      tap((): void => {
        this.aiChatService.sessionTitleUpdated$.next({ sessionId, title: savedTitle });
        this.notificationService.success(
          this.translateService.instant('chat_renamed_successfully'),
          NotificationPosition.Toast,
          true,
          undefined,
          undefined,
          undefined,
          (): void => triggerElement?.focus(),
        );
      }),
      catchError((): typeof EMPTY => {
        this.notificationService.error(
          this.translateService.instant('error_action_cant_be_performed'),
          NotificationPosition.Toast,
          true,
        );
        return EMPTY;
      }),
    );
  }
}
